export default __webpack_public_path__ + "8c463765f15011a162b65a8e75d43c81.png";